import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {AsrRoutePath} from 'projects/ngx-asr-lib/src/lib/constants';

@Component({
  selector: 'app-asr-header-logo',
  templateUrl: './header-logo.component.html'
})
export class HeaderLogoComponent {
  constructor(private router: Router) {}

  openHomePage() {
    this.router.navigate([[AsrRoutePath.ASR_URL, AsrRoutePath.HOME_URL].join('/')]);
  }
}
